import SmartPicsImg from "./SmartPicsImg.jsx";
import './styles/SmartPics.scss';
import first from '../videos/1.1.mp4';
import second from '../videos/1_2.mp4';
import third from '../videos/1_3.mp4';
import fourth from '../videos/1.4.mp4';


function SmartPics() {


    return (
      <div className="examples">
        <ul className="examplesList">
          <SmartPicsImg 
            smartPicSrc={first}
            label="Smart contract insurance policies"
          />
          <SmartPicsImg 
            smartPicSrc={second}
            label="Music"
          />
          <SmartPicsImg 
            smartPicSrc={third}
            label="Crypto collectibles"
          />
          <SmartPicsImg 
            smartPicSrc={fourth}
            label="Domain names"
          />
        </ul>
    </div>
    )
}
            
export default SmartPics;